/* eslint-disable import/prefer-default-export,no-underscore-dangle,@typescript-eslint/ban-ts-comment */
import { v4 as uuidv4 } from 'uuid';
import { groupByActionTypes } from 'redux-undo';

type TAction = { type: string, payload: any };
export const batchGroupBy: {
  _group: null | string;
  start: (x?: string) => void;
  end: () => void;
  init: (rawActions:{ type: string, payload: any }) => any | null
} = {
  _group: null,
  start(group = uuidv4()) {
    this._group = group;
  },
  end() {
    this._group = null;
  },
  init(rawActions) {
    const defaultGroupBy = groupByActionTypes(rawActions);
    // @ts-ignore
    return (action: TAction) => this._group || defaultGroupBy(action);
  },
};
